module.exports = __webpack_public_path__ + "static/logo-wordmark-77d5e93819e860f0da039ec53f3282d7.svg";